import financeiroApi from '../financeiroApi';

const PATH = '/api/v1/backend/fiscal/nbs';

export default {
  buscarNbs: async (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  pesquisarNbs: async (params) => {
    return financeiroApi.get(`${PATH}/pesquisar`, { params });
  },
};
